<template>
  <div class="page">
    <h3 v-if="!hideTitle">결제내역 조회</h3>

    <div class="toolbar">
      <!-- 20006: 센터/이름 개별 검색 + 팝업. role customer 는 내정보 고정·비활성·검색버튼 감춤 -->
      <label>센터</label>
      <!-- 센터, 이름 조회 입력받기 프로젝트 -->
      <input v-model="fCenterName" type="text" class="tin" :disabled="isCustomer" @keyup.enter="reload" />
      <button v-if="!isCustomer" class="ghost" @click="centerDlgOpen=true">검색</button>
      <button v-if="!isCustomer" class="ghost" @click="fCenterName=''">비우기</button>
      <label>이름</label>
      <!-- 센터, 이름 조회 입력받기 프로젝트 -->
      <input v-model="fName" type="text" class="tin" :disabled="isCustomer" @input="fLoginId=''" @keyup.enter="reload" />
      <button v-if="!isCustomer" class="ghost" @click="memberDlgOpen=true">검색</button>
      <button v-if="!isCustomer" class="ghost" @click="fName=''; fLoginId=''">비우기</button>
      <label>기간</label>
      <input v-model="startDate" type="date" />
      <span class="dash">~</span>
      <input v-model="endDate" type="date" />
      <!-- 20006: 조회 범위 콤보는 화면에서 감춤(내부 기본값 전체 유지) -->
      <button @click="reload">조회</button>
    </div>
    <p v-if="msg" class="msg">{{ msg }}</p>

    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr>
            <th>날짜</th><th>센터명</th><th>결제일</th><th>고객명</th><th>로그인id</th><th>주문번호</th>
            <th>결제액</th><th>반품액</th><th>반품철회액</th><th>전체취소액</th>
            <th>PV반환시작일</th><th>PV반환종료일</th><th>PV반환철회시작일</th><th>PV반환철회종료일</th>
            <th>매출액</th><th>구분</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in paged" :key="r.id">
            <td>{{ r.buyDt }}</td>
            <td>{{ r.centerName || '-' }}</td>
            <td>{{ r.payDt || '-' }}</td>
            <td>{{ r.name }}</td>
            <td>{{ r.loginId }}</td>
            <td>{{ r.orderNo }}</td>
            <td class="num">{{ fmt(r.amount) }}</td>
            <td class="num">{{ fmt(r.refundAmt) }}</td>
            <td class="num">{{ fmt(r.refundCancelAmt) }}</td>
            <td class="num">{{ fmt(r.allRetAmt) }}</td>
            <td class="center">{{ r.retRangeSt || '-' }}</td>
            <td class="center">{{ r.retRangeEd || '-' }}</td>
            <td class="center">{{ r.retCancelRangeSt || '-' }}</td>
            <td class="center">{{ r.retCancelRangeEd || '-' }}</td>
            <td class="num">{{ fmt(r.salesAmt) }}</td>
            <td class="center">
              <span v-if="r.manualYn==='B'" class="btag">버튼</span>
              <span v-else-if="r.manualYn==='Y'" class="mtag">수동</span>
              <span v-else>-</span>
            </td>
          </tr>
          <tr v-if="list.length===0"><td colspan="16" class="empty">결제내역이 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <Paging v-if="list.length > 0" :page="page" :size="size" :total-count="list.length" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <!-- 20006: 결제내역 조회 전용 센터/회원 검색 팝업 -->
    <SettlementCenterSearchDialog v-if="centerDlgOpen" @select="onPickCenter" @close="centerDlgOpen=false" />
    <SettlementMemberSearchDialog v-if="memberDlgOpen" @select="onPickMember" @close="memberDlgOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import Paging from '../components/Paging.vue';
import SettlementCenterSearchDialog from '../components/SettlementCenterSearchDialog.vue';
import SettlementMemberSearchDialog from '../components/SettlementMemberSearchDialog.vue';
import { getAuth } from '../store/auth';

export default {
  name: 'PaymentHistory',
  components: { Paging, SettlementCenterSearchDialog, SettlementMemberSearchDialog },
  props: { hideTitle: { type: Boolean, default: false } },   // 스펙104: 화면2 임베드 시 중복 타이틀 숨김
  data() {
    return { fName: '', fLoginId: '', fCenterName: '',
             centerDlgOpen: false, memberDlgOpen: false,
             isCustomer: getAuth().role === 'customer',
             startDate: '', endDate: '', scope: 'all', list: [], msg: '', page: 1, size: 10 };
  },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.list.length / this.size)); },
    paged() {
      const s = (this.page - 1) * this.size;
      return this.list.slice(s, s + this.size);
    }
  },
  async created() {
    // 20006: role customer 는 센터명/이름을 내정보로 고정 표시(비활성).
    if (this.isCustomer) {
      try { const me = (await api.me()).data || {}; this.fCenterName = me.centerName || ''; this.fName = me.name || ''; }
      catch (e) { /* noop */ }
    }
    this.reload();
  },
  methods: {
    fmt(n) { return (Number(n || 0)).toLocaleString(); },
    // 20006: 센터 검색 팝업 선택 → 센터명 채움(자동조회 안 함)
    onPickCenter(c) { this.fCenterName = (c && c.centerName) || ''; this.centerDlgOpen = false; },
    // 20006: 회원 검색 팝업 선택 → 이름 채움(자동조회 안 함)
    onPickMember(m) { this.fName = (m && m.name) || ''; this.fLoginId = (m && m.loginId) || ''; this.memberDlgOpen = false; },
    onPage(p) { this.page = p; },
    onSize(s) { this.size = s; this.page = 1; },
    async reload() {
      this.msg = '';
      try {
        //센터, 이름 조회 입력받기 프로젝트
        const res = await api.paymentHistory({ custLoginId: this.fLoginId, custName: this.fName.trim(), centerName: this.fCenterName.trim(), 
          startDate: this.startDate, endDate: this.endDate, scope: this.scope });
        this.list = res.data || [];
        this.page = 1;
      } catch (e) { this.msg = e.message; this.list = []; }
    }
  }
};
</script>

<style scoped>
.page { padding: 4px; }
.toolbar { display: flex; align-items: center; gap: 8px; margin: 12px 0; flex-wrap: wrap; }
.toolbar label { font-size: 13px; color: #33405c; font-weight: 600; }
.toolbar input[type="date"] { height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 8px; }
.toolbar input.tin { height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 8px; width: 140px; }
.toolbar button.ghost { background: #eef1f7; color: #33415c; border-color: #cfd6e6; }
.toolbar .dash { color: #8a95ab; }
.toolbar button { height: 30px; border: 1px solid #4d8bff; background: #4d8bff; color: #fff; border-radius: 6px; padding: 0 14px; cursor: pointer; font-size: 13px; }
.msg { color: #c0392b; font-size: 13px; margin: 4px 0; }
.table-scroll { overflow-x: auto; border: 1px solid #e4e9f2; border-radius: 8px; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 760px; }
.grid th, .grid td { border-bottom: 1px solid #e4e9f2; padding: 6px 8px; white-space: nowrap; }
.grid thead th { background: #f2f5fb; color: #33405c; }
.grid td.num { text-align: right; }
.grid td.center { text-align: center; }
.grid .empty { text-align: center; color: #8a95ab; padding: 20px; }
.mtag { display: inline-block; padding: 1px 6px; font-size: 10.5px; background: #eaf1ff; color: #2f6fed; border-radius: 8px; }
.btag { display: inline-block; padding: 1px 6px; font-size: 10.5px; background: #e6f5ec; color: #1f9d55; border-radius: 8px; }
</style>
